import React from "react";
import "./Footer.css";

const Footer = () => {
  return <div className="footer">© Designed & Developed by BAH in Lyon – 2025</div>;
};

export default Footer;
